/****************************************************
 * Module Name:  addWorkerModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import WorkerProxy from "../../utility/proxy/worker/workerProxy";
import Constants from "../../utility/constants";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Select from "react-select";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { Box, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

let occurOptions = [
  { value: "ONCE", label: "ONCE" },
  { value: "MULTIPLE", label: "MULTIPLE" },
];

export default class AddWorkerModal extends Component {
  constructor(props) {
    super(props);

    let defaultEverySeconds = 60;
    let currDt = new Date();
    let schDt = new Date();
    schDt.setSeconds(schDt.getSeconds() + parseInt(defaultEverySeconds));

    this.state = {
      newworker: this.props.editOperation ? this.props.sourceData.name : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",
      newOccurs: this.props.editOperation
        ? this.props.sourceData.occurs
        : occurOptions[0].value,
      newevery: this.props.editOperation
        ? this.props.sourceData.every
        : defaultEverySeconds,
      newlastscheduletime: this.props.editOperation
        ? this.props.sourceData.last_schedule_time
        : currDt,
      newnextscheduletime: this.props.editOperation
        ? this.props.sourceData.next_schedule_time
        : schDt,
      newclassname: this.props.editOperation
        ? this.props.sourceData.class_name
        : "",
      newdeleted: this.props.editOperation
        ? this.props.sourceData.deleted
        : false,
      newdisabled: this.props.editOperation
        ? this.props.sourceData.disabled
        : false,

      showError: false,

      validateWorkerPresentSpinner: false,
      showValidationMessage: false,
      workerAvailable: true,

      workerValidationError: "",
      everyValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newworker,
      description: this.state.newdescription,
      occurs: this.state.newOccurs,
      every: this.state.newevery,
      last_schedule_time: this.props.editOperation
        ? Utility.ConvertLocalTimeToUtc(this.state.newlastscheduletime)
        : this.state.newlastscheduletime,
      next_schedule_time: this.props.editOperation
        ? Utility.ConvertLocalTimeToUtc(this.state.newnextscheduletime)
        : this.state.newnextscheduletime,
      class_name: this.state.newclassname,
      deleted: this.state.newdeleted,
      disabled: this.state.newdisabled,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateWorkerPresent = (workerEntered) => {
    if (!workerEntered || workerEntered.trim() === "") return;

    this.setState({
      validateWorkerPresentSpinner: true,
    });

    WorkerProxy.CheckWorkerAvailable(workerEntered, (response) => {
      //if we got response that means worker is present at backend
      if (response) {
        //WorkerName already present
        this.setState({
          validateWorkerPresentSpinner: false,
          showValidationMessage: true,
          workerAvailable: false,
        });
      } else {
        //WorkerName not available, so can be used
        this.setState({
          validateWorkerPresentSpinner: false,
          showValidationMessage: true,
          workerAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (this.props.editOperation && this.state.everyValidationError.length !== 0)
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.workerAvailable ||
        this.state.everyValidationError.length !== 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add worker validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Worker" : "Add New Worker"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Worker Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Worker <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newworker}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          label="Worker (required)"
                          placeholder="Enter Worker"
                          value={this.state.newworker}
                          autoFocus
                          onBlur={(e) =>
                            this.validateWorkerPresent(this.state.newworker)
                          }
                          onChange={(e) =>
                            this.setState({
                              newworker: e.target.value,
                              showValidationMessage: false,
                              workerValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Worker Cannot be Empty",
                            })
                          }
                          helperText={this.state.workerValidationError}
                          error={this.state.workerValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateWorkerPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box></Box>
                      ) : this.state.workerAvailable ? (
                        <font color="green">Worker available</font>
                      ) : (
                        <font color="red">Worker not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Occurs</Form.Label>
                    </td>
                    <td>
                      <Select menuPlacement="auto"
                        blurInputOnSelect={false}
                        className="basic-single"
                        classNamePrefix="select"
                        value={occurOptions.find(
                          (occur) => occur.value === this.state.newOccurs
                        )}
                        menuPortalTarget={document.body}
                        isSearchable={true}
                        name="Occurs"
                        styles={Constants.Styles}
                        options={occurOptions}
                        onChange={(selectedOption) =>
                          this.setState({ newOccurs: selectedOption.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        {this.state.newOccurs === "ONCE" ? "After" : "Every"}
                        &nbsp;(Seconds) <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        type="number"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        fullWidth
                        label={`${this.state.newOccurs === "ONCE" ? "After " : "Every "
                          }(Seconds)(required)`}
                        placeholder={`${this.state.newOccurs === "ONCE" ? "After " : "Every "
                          }(Seconds)`}
                        value={this.state.newevery}
                        onChange={(e) => {
                          let currDt = new Date();
                          let schDt = new Date();
                          schDt.setSeconds(
                            schDt.getSeconds() + parseInt(e.target.value)
                          );
                          this.setState({
                            newevery: e.target.value,
                            newlastscheduletime: currDt,
                            newnextscheduletime: schDt,
                            everyValidationError: !Utility.CheckIsPresent(e.target.value)
                              ? "Seconds Cannot be Empty"
                              : parseInt(e.target.value) < 5
                                ? "Seconds Cannot be less than 5"
                                : "",
                          });
                        }}
                        helperText={this.state.everyValidationError}
                        error={this.state.everyValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Last schedule time</Form.Label>
                    </td>
                    <td>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          ampm={true}
                          renderInput={(props) => (
                            <TextField
                              fullWidth
                              {...props}
                              inputProps={{
                                ...props.inputProps,
                                readOnly: true,
                              }}
                            />
                          )}
                          label="Last schedule time"
                          value={this.state.newlastscheduletime}
                          inputFormat="DD/MM/YYYY hh:mm:ss a"
                          onChange={(newValue) => {
                            let currDt = new Date(newValue.$d);
                            let schDt = new Date(newValue.$d);
                            schDt.setMinutes(
                              schDt.getMinutes() + parseInt(this.state.newevery)
                            );

                            this.setState({
                              newlastscheduletime: currDt,
                              newnextscheduletime: schDt,
                            });
                          }}
                        />
                      </LocalizationProvider>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Next schedule time</Form.Label>
                    </td>
                    <td>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          ampm={true}
                          renderInput={(props) => (
                            <TextField
                              fullWidth
                              {...props}
                              inputProps={{
                                ...props.inputProps,
                                readOnly: true,
                              }}
                            />
                          )}
                          label="Next schedule time"
                          value={this.state.newnextscheduletime}
                          inputFormat="DD/MM/YYYY hh:mm:ss a"
                          onChange={(newValue) =>
                            this.setState({ newnextscheduletime: newValue.$d })
                          }
                        />
                      </LocalizationProvider>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Class Name</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Class Name"
                        placeholder="Enter class name"
                        value={this.state.newclassname}
                        onChange={(e) =>
                          this.setState({ newclassname: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>&nbsp;</Form.Label>
                    </td>
                    <td>
                      <table>
                        <tbody>
                          <tr>
                            <td width="50%">
                              <Form.Check
                                type="checkbox"
                                checked={this.state.newdeleted}
                                label="Deleted"
                                onChange={(e) =>
                                  this.setState({
                                    newdeleted: !this.state.newdeleted,
                                  })
                                }
                              />
                            </td>
                            <td width="50%">
                              <Form.Check
                                type="checkbox"
                                checked={this.state.newdisabled}
                                label="Disabled"
                                onChange={(e) =>
                                  this.setState({
                                    newdisabled: !this.state.newdisabled,
                                  })
                                }
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
